var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFewerSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10C20.6821 10 20.8642 10.0393 21.0304 10.1139L28.4839 13.2522C29.3548 13.6174 30.0039 14.4698 30 15.4988C29.9802 19.3951 28.3652 26.524 21.545 29.7643C20.884 30.0786 20.116 30.0786 19.455 29.7643C12.6348 26.524 11.0198 19.3951 11 15.4988C10.9961 14.4698 11.6452 13.6174 12.5161 13.2522L19.9735 10.1139C20.1358 10.0393 20.3179 10 20.5 10ZM20.5 12.6237V27.4705C25.9625 24.8468 27.431 19.0377 27.4667 15.5538L20.5 12.6237Z",
    fill: "#16A34A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewerSvg);
export default __webpack_public_path__ + "static/media/FewerSvg.8740c580272a3a34287cb4472ffb272b.svg";
export { ForwardRef as ReactComponent };